define('services/externalContactService',[
    'lib/knockout',
    'lib/lodash4',
    'services/apiCore'
], function (
    ko,
    _,
    apiCore
) {
    'use strict';

    var externalContactService =  {
        getExternalContact: function(externalContactId) {
            return apiCore.v2.get('/externalcontacts/contacts/' + externalContactId);
        }
    };

    externalContactService.getCachedExternalContact = _.memoize(externalContactService.getExternalContact);

    return externalContactService;
});

